import type { EntryValueViewT } from "@/types/database/entries";
import type { InputKeyT } from "@/types/database/forms";
import {
	DatePickerEntryValue,
	DateTimePickerEntryValue,
	DefaultEntryValue,
	MultipleChoiceEntryValue,
	ScaleRatingEntryValue,
	YesNoEntryValue,
} from "./input-types";

interface Props {
	value: string | number | boolean | string[] | Date | null;
	inputKey: InputKeyT;
	inputLabel?: string;
	inputId?: string;
	size?: "sm" | "md" | "lg";
}

export function SimpleEntryValueSwitch({
	value,
	inputKey,
	inputLabel,
	inputId,
	size,
}: Props) {
	if (!value) return null;

	switch (inputKey) {
		case "date-picker":
			return (
				<DatePickerEntryValue
					value={value as string}
					inputLabel={inputLabel}
					size={size}
				/>
			);
		case "date-time-picker":
			return (
				<DateTimePickerEntryValue
					value={value as string}
					inputLabel={inputLabel}
					size={size}
				/>
			);
		case "scale-rating":
			if (!inputId) return null;
			return (
				<ScaleRatingEntryValue
					value={value as number}
					inputId={inputId}
					showLabel={false}
					size={size}
				/>
			);
		case "multiple-choice":
			return (
				<MultipleChoiceEntryValue
					value={value as string[]}
					inputLabel={inputLabel}
					size={size}
				/>
			);
		case "yes-no":
			return (
				<YesNoEntryValue
					value={value as string}
					inputLabel={inputLabel}
					size={size}
				/>
			);
		default:
			return (
				<DefaultEntryValue
					value={value as string}
					inputLabel={inputLabel}
					size={size}
				/>
			);
	}
}
